import posthog from "posthog-js"
import type {
	NotificationResponseName,
	TapSource,
} from "@/shared/api/websocket"

const CHANNELS: Record<TapSource, { utm_source: string; utm_medium: string }> =
	{
		push: { utm_source: "firebase", utm_medium: "push" },
		telegram: { utm_source: "telegram", utm_medium: "telegram" },
	}

const OPENED_EVENTS: Record<TapSource, string> = {
	push: "push_opened",
	telegram: "telegram_opened",
}

export function openedEventOf(source: TapSource): string {
	return OPENED_EVENTS[source]
}

// Session super properties ride along on every later event, so no caller passes
// them. A `utm_medium` ending in "push" is what puts the session in the Push
// channel; `utm_content` is stringified — session properties are extracted as
// strings, and a number would land there empty.
export function setTapAttribution(
	source: TapSource,
	notificationId: number | null,
	name: NotificationResponseName | null,
): void {
	let utmContent = "none"
	if (notificationId !== null) utmContent = String(notificationId)
	posthog.register_for_session({
		...CHANNELS[source],
		utm_campaign: name ?? "unknown",
		utm_content: utmContent,
	})
}
